package base.data

data class CanvasInfo(
    val width: Int,
    val height: Int,
)